import { InvoiceType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const invoicesAtom = atom<InvoiceType[]>([]);
const filteredInvoicesAtom = atom<InvoiceType[]>([]);

export default function useInvoices() {
  const [value, setValue] = useAtom(invoicesAtom);
  const [filteredInvoices, setFilteredInvoices] = useAtom(filteredInvoicesAtom);

  return { value, setValue, filteredInvoices, setFilteredInvoices };
}
